import ContactBanner from "./views/ContactBanner";
import ContactBody from "./views/ContactBody";

export default function ContactUs() {
  return (
    <div className="pt-[71px] w-full">
      <ContactBanner />
      <ContactBody />
    </div>
  );
}
